// Constants
import {FORMAZIONE_PAGE} from "constants/pages";

interface SchemaScriptProps {
    urlPath: string;
}

const BreadcrumbSchema = ({ urlPath }: SchemaScriptProps) => {

    const jsonLd = {
        "@context":"http://schema.org",
        "@type":"BreadcrumbList",
        "itemListElement":[
            {
                "@type":"ListItem",
                "position":0,
                "item":{
                    "@id": `${process.env.NEXT_PUBLIC_DOMAIN}`,
                    "name":"home"
                }
            },
            {
                "@type":"ListItem",
                "position":1,
                "item":{
                    "@id":`${process.env.NEXT_PUBLIC_DOMAIN}${FORMAZIONE_PAGE}${urlPath ? `/${urlPath}` : ""}`,
                    "name":"Ricerca"
                }
            }
        ]
    };

    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    );
}

export default BreadcrumbSchema;